import { Component, DestroyRef, EventEmitter, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppModules } from '@common-modules/shared/app-modules.enum';
import { DashboardIdentity } from '../dashboard-identity';

const COMPONENT_SELECTOR = 'wlm-create-dashboard-form';

@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './create-dashboard-form.component.html',
  styleUrl: './create-dashboard-form.component.scss',
  standalone: false,
})
export class CreateDashboardFormComponent {
  @Output() dashboardChange = new EventEmitter<DashboardIdentity>();
  @Output() isValidChange = new EventEmitter<boolean>();

  readonly T_SCOPE = `${AppModules.RightPanel}.${COMPONENT_SELECTOR}`;
  form: FormGroup;

  constructor(
    private readonly _fb: FormBuilder,
    private readonly _destroyRef: DestroyRef,
  ) {}

  ngOnInit() {
    this.form = this._fb.group({
      title: ['', Validators.required],
      //privacy: ['private', Validators.required],
    });

    this.form.valueChanges.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((dashboard) => {
      this.dashboardChange.emit(dashboard);
    });

    this.form.statusChanges.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((validity) => {
      this.isValidChange.emit(validity === 'VALID');
    });
  }
}
